import { Component, Input } from '@angular/core';
import { ScansInterface } from '@monsido/modules/models/api/interfaces/scans.interface';

@Component({
    selector: 'mon-request-checker-article-component',
    templateUrl: 'article.html',
    styleUrls: ['./../../request-checker.scss'],
    standalone: false,
})

export class ArticleComponent {
    @Input() url: string;
    @Input() scan: ScansInterface;
    constructor () {}
}
